import { Component, Input, OnInit } from '@angular/core';
import { IModalRoadworksModel } from '@types-custom/models/ui/modal-roadworks-model';
import { DrawerPanelService } from '@ui-core/services/drawer-panel/drawer-panel.service';
import { Icon } from '@types-custom/models/ui/icon-model';
import { SituationTypeEnum } from '@shared/models/situations.model';

/*
 ** Modal Roadworks
 ** Render a modal that displays information about roads.
 */

@Component({
  selector: 'modal-roadworks',
  templateUrl: './modal-roadworks.component.html',
  styleUrls: ['./modal-roadworks.component.scss'],
})
export class ModalRoadworksComponent implements OnInit {
  @Input() properties: IModalRoadworksModel | undefined;
  Icon = Icon;

  constructor(private drawerPanelService: DrawerPanelService) {}

  ngOnInit() {
    this.drawerPanelService.collapseDrawer(true);
  }
}
